import React from 'react'

import {useParams} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header'
import LeadTrackingSection from '../components/leadTrackingSection';


export default function LeadTracking() {

    const {email} = useParams();
       
    return (
        <>
                <InactivityLogout>
                <Header searchterm={email} />
                <LeadTrackingSection searchterm={email} />
                </InactivityLogout>
        </>
    );
}